import Vue from 'vue';

/**
 * Service API Módulo Extrusão e Fornos
 * Consome os endpoints /api/v1/extrusion-furnace/* via evoAxiosIns ($http2)
 */

function getAxiosInstance() {
  return Vue.prototype.$http2;
}

export function getExtrusionResources(siteId) {
  const http = getAxiosInstance();
  return http.get('/api/v1/extrusion-furnace/resources', {
    params: { siteId }
  });
}

export function getExtrusionPanel(resourceId, operationId = null, orderId = null) {
  const http = getAxiosInstance();
  const params = { resourceId };
  if (operationId) params.operationId = operationId;
  if (orderId) params.orderId = orderId;
  return http.get('/api/v1/extrusion-furnace/panel', { params });
}

export function getExtrusionAlloys() {
  const http = getAxiosInstance();
  return http.get('/api/v1/extrusion-furnace/alloys');
}

export function getExtrusionOrders(resourceId, siteId, optionsOrMaterialId = null) {
  const http = getAxiosInstance();
  const params = { resourceId, siteId };
  if (typeof optionsOrMaterialId === 'object' && optionsOrMaterialId !== null) {
    if (optionsOrMaterialId.materialId) params.materialId = optionsOrMaterialId.materialId;
    if (optionsOrMaterialId.search) params.search = optionsOrMaterialId.search;
    if (optionsOrMaterialId.tab) params.tab = optionsOrMaterialId.tab;
    if (optionsOrMaterialId.statusFilter) params.statusFilter = optionsOrMaterialId.statusFilter;
    if (optionsOrMaterialId.situation) params.situation = optionsOrMaterialId.situation;
    if (optionsOrMaterialId.sortBy) params.sortBy = optionsOrMaterialId.sortBy;
    if (optionsOrMaterialId.page) params.page = optionsOrMaterialId.page;
    if (optionsOrMaterialId.pageSize) params.pageSize = optionsOrMaterialId.pageSize;
  } else if (optionsOrMaterialId) {
    params.materialId = optionsOrMaterialId;
  }
  return http.get('/api/v1/extrusion-furnace/orders', { params });
}

export function getSelectableOrdersForResource(resourceId, siteId, materialId = null) {
  const http = getAxiosInstance();
  const params = { resourceId, siteId };
  if (materialId) params.materialId = materialId;
  return http.get('/api/mysfc/operator/order/selectable-for-resource', { params });
}

export function getSelectableMaterialsForResource(resourceId, siteId, orderId = null) {
  const http = getAxiosInstance();
  const params = { resourceId, siteId };
  if (orderId) params.orderId = orderId;
  return http.get('/api/mysfc/operator/material/selectable-for-resource', { params });
}

export function saveExtrusionProgress(payload) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/progress', payload);
}

export function createTarugoAppointment(payload, siteId) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/progress', payload);
}

export function changeExtrusionStatus(payload) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/status', payload);
}

export function finalizeExtrusion(payload, siteId) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/finalize-extrusion', payload);
}

export function getCuttingRefuses(params) {
  const http = getAxiosInstance();
  return http.get('/api/v1/extrusion-furnace/cutting/refuses', { params });
}

export function saveCuttingRefuses(payload) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/cutting/refuse', payload);
}

export function getCuttingBaskets(params) {
  const http = getAxiosInstance();
  return http.get('/api/v1/extrusion-furnace/cutting/baskets', { params });
}

export function saveCuttingBaskets(payload) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/cutting/baskets', payload);
}

export function finalizeCutting(payload) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/cutting/finalize', payload);
}

export function createCutScraps(payload, siteId) {
  return saveCuttingRefuses(payload);
}

export function createBaskets(payload, siteId) {
  return saveCuttingBaskets(payload);
}

export function getFurnaces(siteId) {
  const http = getAxiosInstance();
  return http.get('/api/v1/extrusion-furnace/furnaces', {
    params: { siteId }
  });
}

export function getAvailableBaskets(siteId) {
  const http = getAxiosInstance();
  return http.get('/api/v1/extrusion-furnace/baskets/available', {
    params: { siteId }
  });
}

export function createFurnaceCharge(arg1, arg2) {
  const http = getAxiosInstance();
  let payload = arg1;
  let siteId = arg2;
  if (typeof arg1 === 'number' || typeof arg1 === 'string') {
    siteId = arg1;
    payload = arg2;
  }
  return http.post('/api/v1/extrusion-furnace/furnaces/charge', payload, {
    params: { siteId }
  });
}

export function updateFurnaceChargeStatus(arg1, arg2) {
  const http = getAxiosInstance();
  let payload = arg1;
  let siteId = arg2;
  if (typeof arg1 === 'number' || typeof arg1 === 'string') {
    siteId = arg1;
    payload = arg2;
  }
  return http.put('/api/v1/extrusion-furnace/furnaces/charge/status', payload, {
    params: { siteId }
  });
}

export function updateFurnaceChargeBaskets(arg1, arg2) {
  const http = getAxiosInstance();
  let payload = arg1;
  let siteId = arg2;
  if (typeof arg1 === 'number' || typeof arg1 === 'string') {
    siteId = arg1;
    payload = arg2;
  }
  return http.put('/api/v1/extrusion-furnace/furnaces/charge/baskets', payload, {
    params: { siteId }
  });
}

export function getFurnaceChargeDetails(chargeId) {
  const http = getAxiosInstance();
  return http.get(`/api/v1/extrusion-furnace/furnaces/charge/${chargeId}`);
}

export function saveCustomParameters(payload, siteId) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/custom-parameters', payload, {
    params: { siteId }
  });
}

export function getCustomParameters(entityType, entityId, siteId) {
  const http = getAxiosInstance();
  return http.get(`/api/v1/extrusion-furnace/custom-parameters/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}`, {
    params: { siteId }
  });
}

export function getCustomFieldTemplate(entityType, siteId) {
  const http = getAxiosInstance();
  return http.get(`/api/v1/extrusion-furnace/custom-templates/${encodeURIComponent(entityType)}`, {
    params: { siteId }
  });
}

export function saveCustomFieldTemplate(entityType, templateJson, siteId) {
  const http = getAxiosInstance();
  return http.post(`/api/v1/extrusion-furnace/custom-templates/${encodeURIComponent(entityType)}`, templateJson, {
    headers: { 'Content-Type': 'application/json' },
    params: { siteId }
  });
}

export function getExtrusionHistory({ operationId, resourceId }) {
  const http = getAxiosInstance();
  return http.get('/api/v1/extrusion-furnace/history', {
    params: { operationId, resourceId }
  });
}

export function deleteExtrusionProgress(id) {
  const http = getAxiosInstance();
  return http.delete(`/api/v1/extrusion-furnace/progress/${id}`);
}

export function deleteCuttingRefuse(id) {
  const http = getAxiosInstance();
  return http.delete(`/api/v1/extrusion-furnace/cutting/refuse/${id}`);
}

export function deleteCuttingBasket(id) {
  const http = getAxiosInstance();
  return http.delete(`/api/v1/extrusion-furnace/cutting/baskets/${id}`);
}

export function updateExtrusionProgress(id, payload) {
  const http = getAxiosInstance();
  return http.put(`/api/v1/extrusion-furnace/progress/${id}`, payload);
}

export function updateCuttingBasket(id, payload) {
  const http = getAxiosInstance();
  return http.put(`/api/v1/extrusion-furnace/cutting/baskets/${id}`, payload);
}

export function updateCuttingRefuse(id, payload) {
  const http = getAxiosInstance();
  return http.put(`/api/v1/extrusion-furnace/cutting/refuse/${id}`, payload);
}

export function reopenExtrusionOrder(payload) {
  const http = getAxiosInstance();
  return http.post('/api/v1/extrusion-furnace/reopen', payload);
}

export function getFurnaceChargesHistory(params) {
  const http = getAxiosInstance();
  return http.get('/api/v1/extrusion-furnace/furnaces/charges/history', { params });
}


